import type { HovSkillId } from "./hovSkillDefinitions";
import { hugeOne, isHugeNumber, type HugeNumber } from "@/shared/numbers";

export type HovSkillModifierSource =
  | "challenge"
  | "exploration"
  | "achievement"
  | "biome"
  | "system";

export type HovSkillModifierTarget = {
  readonly kind: "skill";
  readonly skillId: HovSkillId;
};

export interface HovSkillEffectModifier {
  readonly id: string;
  readonly source: HovSkillModifierSource;
  readonly target: HovSkillModifierTarget;
  readonly multiplier: HugeNumber;
}

export const EMPTY_HOV_SKILL_EFFECT_MODIFIERS: readonly HovSkillEffectModifier[] =
  [];

export function resolveHovSkillExternalMultiplier(
  skillId: HovSkillId,
  modifiers: readonly HovSkillEffectModifier[] = EMPTY_HOV_SKILL_EFFECT_MODIFIERS,
): HugeNumber {
  let multiplier = hugeOne();

  for (const modifier of modifiers) {
    if (
      modifier.target.kind !== "skill" ||
      modifier.target.skillId !== skillId
    ) {
      continue;
    }
    assertPositiveFiniteMultiplier(modifier);
    multiplier = multiplier.mul(modifier.multiplier);
  }

  return multiplier;
}

function assertPositiveFiniteMultiplier(
  modifier: HovSkillEffectModifier,
): void {
  if (
    !isHugeNumber(modifier.multiplier) ||
    !modifier.multiplier.isFinite() ||
    modifier.multiplier.lte(0)
  ) {
    throw new Error(
      `hov skill modifier ${modifier.id} multiplier must be a positive finite HugeNumber`,
    );
  }
}
